var AuthenticityQuestions = function() {
	var page = $('[data-page="authenticity-questions"]');
	var comp = $('[data-component="user-authenticity-questions"]');

	function init() {
		addListeners();
		formValidate();
	}

	function addListeners() {
		// Prossegue para a próxima etapa
		page.find('.continue').on('click', function(e) {
			e.preventDefault();

			if (comp.find('#uaq-form').valid()) {
				comp.find('#uaq-form').trigger('submit');
			}
		});
	}

	// Define os campos a serem validados
	function formValidate() {
		comp.find('#uaq-form').validate({
			rules: {
				question1: {
					"required": true,
					"optionsEquals": true
				},
				answer1: "required",
				confirmAnswer1: "required",
				question2: {
					"required": true,
					"optionsEquals": true
				},
				answer2: "required",
				confirmAnswer2: "required",
				question3: {
					"required": true,
					"optionsEquals": true
				},
				answer3: "required",
				confirmAnswer3: "required",
				question4: {
					"required": true,
					"optionsEquals": true
				},
				answer4: "required",
				confirmAnswer4: "required",
				question5: {
					"required": true,
					"optionsEquals": true
				},
				answer5: "required",
				confirmAnswer5: "required"
			}
		});
	}

	return init();
}

$(document).ready(function() {
	if ($('[data-page="authenticity-questions"]').length > 0) {
		new AuthenticityQuestions();
	}
});
